"use strict";

(function (Drupal) {
  Drupal.behaviors.globalAnimation = {
    attach: function attach(context, settings) {
      var headerOffset = 130;
      var body = document.body;
      var sections = gsap.utils.toArray('[data-animation]');
      if (!sections || body.classList.contains('layout-builder--is-enabled')) {
        return;
      }
      var animateElement = function animateElement(element) {
        element.dataset.animation = true;
      };
      sections.forEach(function (section) {
        gsap.to(section, {
          scrollTrigger: {
            trigger: section,
            start: 'top 70%',
            scrub: true,
            end: function end() {
              return '+=' + section.clientHeight + headerOffset;
            },
            markers: false,
            onEnter: function onEnter() {
              return animateElement(section);
            }
          }
        });
      });
    }
  };
})(Drupal);